import { makeStyles } from '@mui/styles';
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 680,
    flex: 2,
    padding: '0px 15px',
  },
  sectionTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    fontSize: '28px'
  },
  subtitle: {
    marginBottom: 24,
  },
  container: {
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    minWidth: 680,
    // width: '100%',
    backgroundColor: 'white',
    maxHeight: 'calc(100vh - 357px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'fit-content',
    flex: 2,
  },
  header: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  body: {
    borderTop: `1px solid ${colors.neutral200}`,
    borderBottom: `1px solid ${colors.neutral200}`,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  medicationBody: {
    backgroundColor: colors.neutral50,
    display: 'flex',
    gap: 12,
    overflowY: 'auto',
  },
  card: {
    background: colors.white,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 8,
    gap: 8,
    boxShadow: '0px 2px 6px 0px #0000000A',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
  },
  cardSubTitle: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  descriptionText: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral600,
    padding: '16px 32px 24px',
  },
  addBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: '100%',
    color: colors.primary500,
    display: 'flex',
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  addPossibilityBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: 59,
    height: 40,
    color: colors.primary600,
    borderColor: colors.primary300,
  },
  iconContainer: {
    width: '44px',
    height: '44px',
    padding: '12px',
    gap: '8px',
    borderRadius: '6px',
  },
  aiText: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral900,
    //marginTop: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px',
  },
  caseNotesIcon: {
    width: 16,
    height: 16,
  },
  caseNotesCardFooter: {
    borderTop: `1px solid ${colors.neutral100}`,
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    gap: 32,
    alignItems: 'center',
  },
  caseNotesFooterBlock: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  possibility: {
    color: colors.secondary500,
  },
  iconWrapper: ({ status }) => ({
    height: 40,
    width: 40,
    borderRadius: 4,
    border: '1px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors[status === 'normal' ? 'purple50' : `${status}50`],
    borderColor: colors[status === 'normal' ? 'purple200' : `${status}200`],
    [`&.${status}`]: {
      '& svg path': {
        fill: colors[`${status}500`],
      },
    },
    '&.RELEASE_OF_INFORMATION': {
      backgroundColor: colors.indigo50,
      borderColor: colors.indigo200,
      '& svg path': {
        fill: colors.indigo500,
      },
    },
    '&.LAB_REQUEST': {
      backgroundColor: colors.green50,
      borderColor: colors.green200,
      '& svg path': {
        fill: colors.green500,
      },
    },
    '&.CONTACT': {
      backgroundColor: colors.rose50,
      borderColor: colors.rose200,
      '& svg path': {
        fill: colors.rose500,
      },
    },
    '&.GENERAL': {
      backgroundColor: colors.purple50,
      borderColor: colors.purple200,
      '& svg path': {
        fill: colors.purple500,
      },
    },
    '&.CAUTION': {
      backgroundColor: colors.warning50,
      borderColor: colors.warning200,
      '& svg path': {
        fill: colors.warning500,
      },
    },
    '&.PROHIBITIVE': {
      backgroundColor: colors.destructive50,
      borderColor: colors.destructive200,
      '& svg path': {
        fill: colors.destructive500,
      },
    },
    '&.PHARMACY_ASSISTANCE': {
      backgroundColor: colors.cyan50,
      borderColor: colors.cyan100,
      '& svg path': {
        fill: colors.cyan500,
      },
    },
    '&.REFERRAL_OUT': {
      backgroundColor: colors.orange50,
      borderColor: colors.orange200,
      '& svg path': {
        fill: colors.orange500,
      },
    },
    '&.PRIOR_AUTHORIZATION': {
      backgroundColor: colors.primary50,
      borderColor: colors.primary100,
      '& svg path': {
        fill: colors.primary500,
      },
    },
  }),
  footer: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  footerText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  footerBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    maxHeight: '20px',
  },
  bodyUuid: {
    fontWeight: 400,
    fontSize: 36,
    lineHeight: '44px',
    color: colors.neutral900,
  },
  bodyServiceName: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
});
